module.exports = __webpack_public_path__ + "img/total-week.bf22a6f6.svg";